/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { AlarmResolutionType } from "./AlarmResolutionType";
import {
  AlarmResolutionTypeFromJSON,
  AlarmResolutionTypeFromJSONTyped,
  AlarmResolutionTypeToJSON,
  AlarmResolutionTypeToJSONTyped,
} from "./AlarmResolutionType";

/**
 *
 * @export
 * @interface SignalAlarm
 */
export interface SignalAlarm {
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  signalAlarmId?: string;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  signalName?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  rulePrefix?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  alarmStartedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  alarmEndedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  resolvedBy?: string | null;
  /**
   *
   * @type {AlarmResolutionType}
   * @memberof SignalAlarm
   */
  resolutionType?: AlarmResolutionType | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  resolutionNote?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  acknowledgedBy?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  acknowledgedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  acknowledgedNote?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  silencedUntil?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  silencedBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  silenceReason?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  lastSignalSuccessTimestamp?: OffsetDateTime | null;
  /**
   *
   * @type {number}
   * @memberof SignalAlarm
   */
  businessDaysElapsed?: number | null;
  /**
   *
   * @type {number}
   * @memberof SignalAlarm
   */
  businessDayThreshold?: number | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  serviceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  severity?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarm
   */
  updatedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  slackMessageTimestamp?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  slackChannel?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  lastLiveShipmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarm
   */
  lastDeliveredShipmentId?: string | null;
}

/**
 * Check if a given object implements the SignalAlarm interface.
 */
export function instanceOfSignalAlarm(value: object): value is SignalAlarm {
  return true;
}

export function SignalAlarmFromJSON(json: any): SignalAlarm {
  return SignalAlarmFromJSONTyped(json, false);
}

export function SignalAlarmFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalAlarm {
  if (json == null) {
    return json;
  }
  return {
    signalAlarmId:
      json["signalAlarmId"] == null ? undefined : json["signalAlarmId"],
    signalName: json["signalName"] == null ? undefined : json["signalName"],
    rulePrefix: json["rulePrefix"] == null ? undefined : json["rulePrefix"],
    alarmStartedAt:
      json["alarmStartedAt"] == null ? undefined : json["alarmStartedAt"],
    alarmEndedAt:
      json["alarmEndedAt"] == null ? undefined : json["alarmEndedAt"],
    resolvedBy: json["resolvedBy"] == null ? undefined : json["resolvedBy"],
    resolutionType:
      json["resolutionType"] == null
        ? undefined
        : AlarmResolutionTypeFromJSON(json["resolutionType"]),
    resolutionNote:
      json["resolutionNote"] == null ? undefined : json["resolutionNote"],
    acknowledgedBy:
      json["acknowledgedBy"] == null ? undefined : json["acknowledgedBy"],
    acknowledgedAt:
      json["acknowledgedAt"] == null ? undefined : json["acknowledgedAt"],
    acknowledgedNote:
      json["acknowledgedNote"] == null ? undefined : json["acknowledgedNote"],
    silencedUntil:
      json["silencedUntil"] == null ? undefined : json["silencedUntil"],
    silencedBy: json["silencedBy"] == null ? undefined : json["silencedBy"],
    silenceReason:
      json["silenceReason"] == null ? undefined : json["silenceReason"],
    lastSignalSuccessTimestamp:
      json["lastSignalSuccessTimestamp"] == null
        ? undefined
        : json["lastSignalSuccessTimestamp"],
    businessDaysElapsed:
      json["businessDaysElapsed"] == null
        ? undefined
        : json["businessDaysElapsed"],
    businessDayThreshold:
      json["businessDayThreshold"] == null
        ? undefined
        : json["businessDayThreshold"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    severity: json["severity"] == null ? undefined : json["severity"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    slackMessageTimestamp:
      json["slackMessageTimestamp"] == null
        ? undefined
        : json["slackMessageTimestamp"],
    slackChannel:
      json["slackChannel"] == null ? undefined : json["slackChannel"],
    lastLiveShipmentId:
      json["lastLiveShipmentId"] == null
        ? undefined
        : json["lastLiveShipmentId"],
    lastDeliveredShipmentId:
      json["lastDeliveredShipmentId"] == null
        ? undefined
        : json["lastDeliveredShipmentId"],
  };
}

export function SignalAlarmToJSON(json: any): SignalAlarm {
  return SignalAlarmToJSONTyped(json, false);
}

export function SignalAlarmToJSONTyped(
  value?: SignalAlarm | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    signalAlarmId: value["signalAlarmId"],
    signalName: value["signalName"],
    rulePrefix: value["rulePrefix"],
    alarmStartedAt: value["alarmStartedAt"],
    alarmEndedAt: value["alarmEndedAt"],
    resolvedBy: value["resolvedBy"],
    resolutionType: AlarmResolutionTypeToJSON(value["resolutionType"]),
    resolutionNote: value["resolutionNote"],
    acknowledgedBy: value["acknowledgedBy"],
    acknowledgedAt: value["acknowledgedAt"],
    acknowledgedNote: value["acknowledgedNote"],
    silencedUntil: value["silencedUntil"],
    silencedBy: value["silencedBy"],
    silenceReason: value["silenceReason"],
    lastSignalSuccessTimestamp: value["lastSignalSuccessTimestamp"],
    businessDaysElapsed: value["businessDaysElapsed"],
    businessDayThreshold: value["businessDayThreshold"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    severity: value["severity"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
    slackMessageTimestamp: value["slackMessageTimestamp"],
    slackChannel: value["slackChannel"],
    lastLiveShipmentId: value["lastLiveShipmentId"],
    lastDeliveredShipmentId: value["lastDeliveredShipmentId"],
  };
}
